import Vue from 'vue';
import VuetifyConfirm from 'vuetify-confirm'
Vue.use(VuetifyConfirm,{
  buttonTrueText: 'SI',
  buttonFalseText: 'NO',
  buttonTrueColor: 'success',
  buttonFalseColor: 'error',
})

/*Vue.use(VuetifyConfirm, {
    buttonTrueText: 'Accept',
    buttonFalseText: 'Discard',
    color: 'warning',
    icon: 'warning',
    title: 'Warning',
    width: 350,
    property: '$confirm'
  })*/
